import { render } from "./TopPage.vue?vue&type=template&id=84fb35a4&scoped=true&ts=true"
import script from "./TopPage.vue?vue&type=script&lang=ts"
export * from "./TopPage.vue?vue&type=script&lang=ts"

import "./TopPage.vue?vue&type=style&index=0&id=84fb35a4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84fb35a4"]])

export default __exports__